/* RIZZI · Complete the look: loads the pieces after the page, keeps them in step with the chosen colour
   and keeps adding pieces (8 at a time) when the shopper nears the end of the carousel. */
(function () {
  if (customElements.get('rizzi-complete-look')) return;

  const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  class RizziCompleteLook extends HTMLElement {
    connectedCallback() {
      this.current = '';
      const start = () => {
        if (this.started) return;
        this.started = true;
        if (this.io) this.io.disconnect();
        this.load(this.dataset.variant);
      };
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver((entries) => {
          if (entries.some((e) => e.isIntersecting)) start();
        }, { rootMargin: '600px 0px' });
        this.io.observe(this);
      } else {
        start();
      }
      /* Also start once the page has finished loading and the browser is idle, so the pieces are ready before the shopper scrolls down. */
      const idle = () => (window.requestIdleCallback || ((cb) => setTimeout(cb, 1200)))(start, { timeout: 3000 });
      if (document.readyState === 'complete') idle();
      else window.addEventListener('load', idle, { once: true });
      if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.variantChange) {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const variant = event && event.data && event.data.variant;
          if (!variant || !this.loaded || String(variant.id) === this.current) return;
          this.load(variant.id);
        });
      }
      /* Size / option change updates the price shown on that card. */
      this.addEventListener('change', (event) => {
        const select = event.target;
        if (!select.classList || !select.classList.contains('rzcl__select')) return;
        const option = select.selectedOptions[0];
        const card = select.closest('.rzcl__card');
        if (!option || !card) return;
        card.querySelector('.rzcl__now').textContent = option.dataset.price || '';
        const was = card.querySelector('.rzcl__was');
        if (was) {
          was.textContent = option.dataset.compare || '';
          was.hidden = !option.dataset.compare;
        }
      });
    }

    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      if (this.unsubscribe) this.unsubscribe();
    }

    load(variantId) {
      this.current = String(variantId || '');
      const url = this.dataset.url + (variantId ? '&variant=' + variantId : '');
      fetch(url)
        .then((r) => (r.ok ? r.text() : ''))
        .then((html) => {
          this.loaded = true;
          const box = html ? new DOMParser().parseFromString(html, 'text/html').querySelector('.rzcl') : null;
          if (!box) {
            this.replaceChildren();
            this.hidden = true;
            return;
          }
          this.hidden = false;
          this.replaceChildren(document.importNode(box, true));
          this.bind();
        })
        .catch(() => {});
    }

    bind() {
      const box = this.querySelector('.rzcl');
      const track = this.querySelector('.rzcl__track');
      if (!box || !track) return;
      const prev = this.querySelector('[data-rzcl-dir="-1"]');
      const next = this.querySelector('[data-rzcl-dir="1"]');
      const step = () => {
        const card = track.querySelector('.rzcl__card');
        return card ? card.getBoundingClientRect().width + 14 : track.clientWidth / 2;
      };
      [prev, next].forEach((btn) => {
        if (!btn) return;
        btn.addEventListener('click', () => track.scrollBy({ left: step() * Number(btn.dataset.rzclDir), behavior: 'smooth' }));
      });

      /* Endless part: after the chosen pieces, keep going through the same collections, then the whole shop. */
      const sources = (box.dataset.more || '')
        .split(',')
        .filter(Boolean)
        .map((handle) => ({ handle, page: 0, done: false }));
      const seen = new Set([box.dataset.self]);
      track.querySelectorAll('[data-pid]').forEach((n) => seen.add(n.dataset.pid));
      /* One colour per design in the endless part (each colour is its own product). */
      const nameOf = (li) => {
        const t = li.querySelector('.rzcl__title');
        return t ? t.textContent.split(' – ')[0].trim().toLowerCase() : '';
      };
      const seenName = new Set();
      track.querySelectorAll('.rzcl__card').forEach((li) => seenName.add(nameOf(li)));
      const own = document.querySelector('.product__title h1');
      if (own) seenName.add(own.textContent.split(' – ')[0].trim().toLowerCase());
      let busy = false;
      let cursor = 0;
      let finished = !sources.length;

      const fetchPage = (source) => {
        source.page += 1;
        const url = ROOT + 'collections/' + source.handle + '?section_id=rizzi-cl-more&page=' + source.page;
        return fetch(url)
          .then((r) => (r.ok ? r.text() : ''))
          .then((html) => {
            const list = html ? new DOMParser().parseFromString(html, 'text/html').querySelector('.rzcl-more') : null;
            if (!list) {
              source.done = true;
              return [];
            }
            if (source.page >= Number(list.dataset.pages || 0)) source.done = true;
            return Array.from(list.children);
          })
          .catch(() => {
            source.done = true;
            return [];
          });
      };

      const more = async () => {
        if (busy || finished) return;
        busy = true;
        let added = 0;
        let rounds = 0;
        while (added < 6 && rounds < 6 && track.isConnected) {
          rounds += 1;
          const open = sources.filter((s) => !s.done && s.handle !== 'all');
          const list = open.length ? open : sources.filter((s) => !s.done);
          if (!list.length) {
            finished = true;
            break;
          }
          const batch = [];
          for (let i = 0; i < Math.min(3, list.length); i++) batch.push(list[(cursor + i) % list.length]);
          cursor += batch.length;
          const results = await Promise.all(batch.map(fetchPage));
          if (!track.isConnected) break;
          const frag = document.createDocumentFragment();
          const longest = Math.max(0, ...results.map((r) => r.length));
          for (let i = 0; i < longest; i++) {
            results.forEach((r) => {
              const li = r[i];
              if (!li || seen.has(li.dataset.pid)) return;
              seen.add(li.dataset.pid);
              const name = nameOf(li);
              if (name && seenName.has(name)) return;
              seenName.add(name);
              frag.appendChild(document.importNode(li, true));
              added += 1;
            });
          }
          track.appendChild(frag);
        }
        busy = false;
        sync();
      };

      const sync = () => {
        const max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = finished && track.scrollLeft >= max;
        /* Start fetching while about two screens of pieces are still left. */
        if (!finished && track.scrollWidth - track.scrollLeft - track.clientWidth < track.clientWidth * 2) more();
      };
      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    }
  }

  customElements.define('rizzi-complete-look', RizziCompleteLook);
})();